exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group[data-v-15738940]{margin-bottom:10px}.full-width[data-v-15738940]{width:100%}.small-italic[data-v-15738940]{font-size:smaller;font-style:italic}.checkbox-label-container[data-v-15738940]{align-items:center}::-webkit-input-placeholder{font-size:12px}:-moz-placeholder,::-moz-placeholder{font-size:12px}:-ms-input-placeholder{font-size:12px}.optional-text[data-v-15738940]{font-style:italic;opacity:.6}.error-message[data-v-15738940]{color:red;font-size:.8rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-15738940","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/_modules/EvedPay/requestPhysicalCard.vue
// module id = 16cW
// module chunks = 12